<template>
  <div class="marketProjectReview">
    <div class="marketProjectReviewTitle">
      <span style="font-size: 20px">市场项目</span>
      <el-button plain size="mini" @click="createdProject">创建项目</el-button>
    </div>

    <div
      class="marketProjectReviewContent"
      style="
        max-height: calc(100% - 130px);
        overflow-y: auto;
        min-height: calc(100% - 130px);
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
      "
    >
      <div
        v-for="(o, id) in marketProjectReview"
        :key="id"
        class="text item"
        style="width: 29.5%; height: 200px; margin: 20px"
      >
        <el-card class="box-card">
          <div class="photoDiv">
            <img class="photo" style="width: 100%; height: 150px" :src="o.cover" />
            <p :title="o.content">{{ o.content }}</p>
          </div>
          <div
            style="
              display: flex;
              justify-content: space-around;
              align-items: center;
            "
          >
            <p
            :title="o.projectName"
              style="
                width: 250px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ o.projectName }}
            </p>
            <div style="display: flex">
              
              <i v-if="o.status != 1"
                class="el-icon-delete"
                @click="del(o)"
                style="cursor: pointer"
              ></i>
              <i
								v-if="o.status != 1"
                class="el-icon-edit-outline"
                @click="open_dialog(o)"
                style="cursor: pointer"
              ></i>
              <i class="el-icon-s-promotion" @click="issue(o)" style="cursor: pointer"></i>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 市场项目管理分页 -->
    <div class="selectePages">
      <el-pagination
        @size-change="classCompanySizeChange"
        @current-change="classCompanyCurrentChange"
        :current-page.sync="totalObj.currentPage"
        background
        :page-sizes="[10, 20, 50, 100]"
        :page-size="totalObj.pageSize"
        layout="sizes, prev, pager, next"
        :total="totalObj.total"
      ></el-pagination>
    </div>
    <el-dialog
      destroy-on-close
      title="创建项目"
      :visible.sync="dialogVisible"
      width="500px"
      style="border-radius: 25px"
       center
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="项目名称" prop="projectName">
          <el-input
            style="width: 290px"
            v-model="ruleForm.projectName"
          ></el-input>
        </el-form-item>
        <el-form-item label="项目简介" prop="content">
          <el-input
            style="width: 290px"
            type="textarea"
            v-model="ruleForm.content"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联科目" prop="subjectId">
          <el-select
            style="width: 290px"
            v-model="ruleForm.subjectId"
            placeholder="请选择资源"
          >
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="upload_custom" label="上传图片" prop="cover">
          <el-upload
          :limit="1"
            :file-list="flieList"
            list-type="picture-card"
            ref="addUpload"
            :action="materialForm.url"
            :headers="headers"
            :on-success="handleAvatarSuccess"
          >
            <i class="el-input__icon el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <div style="text-align: center !important">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave('ruleForm')"
            >确 定</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- <div
      style="display: flex;flex-wrap: wrap;margin:0 auto"
    >
      <div style="width:33%;display:flex;justify-content: center;" v-for="(o, id) in marketProjectReview" :key="id" class="text item">
        <el-card class="box-card">
          <div class="card_text" style="position: relative">
            <img
              style="
                height: 131px;
                width: 234px;
                position: absolute;
                z-index: 1;
              "
              :src="o.cover"
            />
            <span style="z-index: 1; font-size: 15px">{{ o.content }}</span>
          </div>
          <div
            style="
              margin: 5px;
              position: relative;
              top: 145px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            {{ o.projectName }}
            <div style="display: flex">
              <i
                class="el-icon-delete"
                @click="del(o)"
                style="cursor: pointer"
              ></i>
              <i
                class="el-icon-edit-outline"
                @click="open_dialog(o)"
                style="cursor: pointer"
              ></i>
              <i class="el-icon-s-promotion" style="cursor: pointer"></i>
            </div>
          </div>
        </el-card>
      </div>
    </div> -->
  </div>
</template>

<script>
import bus from "../../../bus/bus";
import * as api1 from "../../../api/courseApi";
import * as api from "../../../api/marketingProjectManagement"; // 内容展示

export default {
  data() {
    return {
      marketProjectReview: [],
      professional: sessionStorage.getItem("professional"),
      materialForm: {
        url: `${process.env.UPLOAD_NAME}/fileUpload/uploadFile`,
        data: {
          savepath: "cjdd/resourse/",
        },
        fileName: "",
        id: "",
      },
      subjectId: "",
      project_name: "",
      dialogVisible: false,
      project_introduction: "",
      projectList: [],
      projectName: "",
      
      content: "",
      id: "",
      pageSize: 10,
      subjectList: [],
      flieList: [],
      ruleForm: {
        projectName: "",
        content: "",
        subjectId:"",
        cover: "",
      },
      totalObj: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      rules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入项目简介", trigger: "blur" },
        ],
        subjectId:[
          { required: true, message: "请选择资源", trigger: "change" },
        ],
      },
      returnParameters:2,
    };
  },

  created() {
    this.init();
  },
  computed: {
    headers() {
      return {
        Authorization: "bearer " + localStorage.getItem("Authorization"),
      };
    },
  },
  methods: {
    issue(o){
      console.log(o,"o");
      if (o.status==0) {
        let params = {
        id : o.id,
        status : 1,
      }
            api.projectPublish(params).then((res) => {
        if (res.code == 0) {
          this.init();
          this.$message({
            type: "success",
            message: "发布成功!",
          });
        }else{
          this.$message({
              message: "发布失败",
              type: "warning",
            });
        }
      });
      }else{
                let params = {
        id : o.id,
        status : 0,
      }
            api.projectPublish(params).then((res) => {
        if (res.code == 0) {
          this.init();
          this.$message({
            type: "success",
            message: "已取消发布!",
          });
        }
      });
      }
      

    },
    //分页
    classCompanySizeChange(val) {
      this.totalObj.pageSize = val;
      this.init();
    },
    classCompanyCurrentChange(val) {
      this.totalObj.currentPage = val;
      this.init();
    },
    init() {
      this.params = {
        professionalId: this.professional,
        pageSize: this.totalObj.pageSize,
        pageNo: this.totalObj.currentPage,
      };
      api.projectList(this.params).then((res) => {
        if (res.code == 0) {
          console.log(res.data, "qqqqqqqqq");
          this.marketProjectReview = res.data.list;
          this.projectList = res.data;
          this.totalObj.total = res.data.total;
        }
      });
    },
    // 获取学生列表
    open_dialog(a) {
      console.log(a.subjectId,"asdasdasdas");
      localStorage.setItem("returnParameters",this.returnParameters)
      this.id = a.id;
      console.log(a.subjectId,"a.subjectId");
      console.log(a.status,"status");
      this.$router.push({
        path: "/newRealTask/components/marketingProjectContent",
        query: {id: this.id, ...a, subjectId: a.subjectId ,status:a.status},
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.cover = res.data.newAttaUrl;
      } else {
        let fileId = file.uid;
        this.showUploadFileList.forEach((item) => {
          if (item.uid == fileId) {
            item.state = "上传失败";
          }
        });
        this.$message.error("格式不支持上传");
      }
    },
    //保存
    handleSave(formName) {
      console.log(this.cover,"this.cover");
      this.$refs[formName].validate((valid) => {
        if (valid) {
            if(this.cover==""){
              this.$message({
              message: "请上传图片",
              type: "warning",
            });
            return
            }
          this.dialogVisible = false;
          let params = {
            id:"",
            projectName: this.ruleForm.projectName,
            cover: this.cover,
            content: this.ruleForm.content,
            subjectId: this.ruleForm.subjectId,
            professionalId: this.professional,
          };
          if (
            this.ruleForm.projectName != "" &&
            this.cover != "" &&
            this.ruleForm.content != "" &&
            this.ruleForm.subjectId != ""
          ) {
            api.saveOrUpdate(params).then((res) => {
              if (res.code == 0) {
                this.init();
                this.$message({
                  message: this.id == "" ? "新增成功" : "修改成功",
                  type: "success",
                });
              }
            });
          } else {

            this.dialogVisible = true;
            this.$message({
              message: "保存失败",
              type: "warning",
            });
          }
        } else {
          return false;
        }
      });
    },
    createdProject() {
      this.cover = "";
      this.dialogVisible = true;
      this.projectName = "";
      this.content = "";
      this.subjectList = []
      //获取科目列表
      let that = this;
      api1.getSubjectList()
        .then((rs) => {
          if (rs.code == 0) {
            rs.data.forEach((item) => {
              //professionId==3   是智能估值
              if (item.professionId == this.professional) {
                this.subjectList.push(item);
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //删除
    del(a) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.id = a.id;
          let params = {
            id: this.id,
          };
          api.projectCatalogDelete(params).then((res) => {
            if (res.code == 0) {
              this.init();
            }
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.marketProjectReview {
  cursor: default;
  width: 1062px;
  height: 100%;
  //   & > div {
  //   height: 100%;
  // }
  .marketProjectReviewTitle {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: white;
    p {
      color: #004e96;
      font-weight: 600;
      font-size: 20px;
      cursor: default;
    }
  }
    .photoDiv {
    position: relative;
    transition: width 0.5s;
  }
  .photoDiv p {
    display: none;
    text-decoration: none;
  }

  .photo:hover {
    filter: blur(5px);
  }
  .photoDiv:hover p {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }


  span,
  i {
    cursor: pointer;
  }
  .selectePages {
    height: 50px;
    width: 100%;
    text-align: right;
    margin-top: 20px;
  }
  .upload_custom {
    .el-upload--picture-card,
    .el-upload-list__item {
      width: 80px;
      height: 80px;
    }

    .el-input__icon {
      line-height: 80px;
    }

    .el-upload {
      line-height: 80px;
    }
  }
  .box-card {
    height: 190px;
    width: 260px;
    margin: 15px;
  }

  .el-dialog {
    border-radius: 25px !important;
  }

  .el-card__body,
  .el-main {
    padding: 0px !important;
    margin: 10px 10px 5px 12.5px;
  }

  .text {
    font-size: 14px;
  }

  .el-icon-delete,
  .el-icon-edit-outline,
  .el-icon-s-promotion {
    margin: 5px 10px 5px 10px;
  }

  .card_text span {
    display: none;
    text-decoration: none;
  }

  .card_text:hover span {
    display: block;

    position: absolute;

    top: 0;

    left: 0;

    color: black;

    font-size: 14px;
  }

  .card_text img {
    transition: all 1s ease;
  }

  .card_text:hover img {
    filter: blur(5px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/newRealTask/components/marketProjectReview.vue